module.exports = __webpack_public_path__ + "img/icon_map_37_off_001.ad7d5082.png";